module.exports = __webpack_public_path__ + "8cea1d9a1a61b9d6fb48a1d84369e0c4.png";